<!--
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-12-11 18:18:56
 * @LastEditors: linfangxing@jinlingkeji.cn linfangxing@jinlingkeji.cn
 * @LastEditTime: 2024-04-11 10:15:01
 -->
<!--
 * @Author: wjw
 * @Github: https://github.com/wangjiawei2019
 * @Date: 2019-06-27 20:32:44
 * @LastEditors: wjw
 * @LastEditTime: 2019-12-11 17:45:08
 -->
<template>
  <div id="app">
    <header class="header">
      <div class="bg-img">
        <!--背景图片-->
      </div>
      <img src="./assets/logo.png" />
      <p class="dialog-search">
        <el-input
          placeholder="请输入要查询的内容"
          v-model="searchKey"
          @keyup.enter.native="handleSearch"
        >
          <i
            slot="suffix"
            class="el-input__icon el-icon-search"
            @click="handleSearch"
          ></i>
        </el-input>
      </p>
      <!-- <ul class="translation-font">
        <li>繁</li>
        <span>|</span>
        <li>简</li>
      </ul>-->
    </header>

    <el-menu
      ref="el-menu"
      default-active="1"
      class="nav"
      background-color="#8c0e01"
      text-color="#EFEFEF"
      active-text-color="#fff"
      mode="horizontal"
      @select="handleSelect"
    >
      <el-menu-item
        class="level-one"
        :class="{ _active: nav == 1 }"
        index="1"
        @click="handleNavClick('/', 1)"
        >首页</el-menu-item
      >

      <el-submenu
        v-for="(navigator, i) in menuList"
        :key="i"
        :index="i + ''"
        :popper-class="'popper' + i"
      >
        <template slot="title">
          <span
            class="level-one"
            :class="{ _active: nav == i + 2 }"
            @click="
              handleNavClick(
                `/${navigator.key}/${navigator.subNav[0].id}`,
                i + 2
              )
            "
            >{{ navigator.name }}</span
          >
        </template>
        <el-menu-item
          v-for="(kid, m) in navigator.subNav"
          :key="m"
          :index="m + ''"
          >{{ kid.name }}</el-menu-item
        >
      </el-submenu>
    </el-menu>

    <router-view v-if="storeMenuList.length" />
    <footer class="website-description">
      <p>友情链接</p>
      <div>
        <a href="http://www.gov.cn" target="_blank">中国政府网站</a>
        |
        <a href="http://www.cncaprc.gov.cn/" target="_blank"
          >全国老龄工作委员会</a
        >
        |
        <a href="http://www.cadf.org.cn/" target="_blank"
          >中国老龄事业发展基金会</a
        >
        |
        <a href="http://www.moe.gov.cn/" target="_blank">教育部网站</a>
        |
        <a href="http://www.cncaprc.cn/" target="_blank">全国中老年网</a>
        |
        <a href="http://www.moa.gov.cn/sjzz/tuixiuganbu/lgbyd/" target="_blank"
          >中国农业部老干部网</a
        >
        |
        <a href="http://www.mca.gov.cn/" target="_blank"
          >中华人民共和国民政部</a
        >
      </div>
      <div>
        地址：北京市朝阳区霄云路 40 号院 1 号楼国航世纪大厦 15 层
        1504、1505、1506 室，邮政编码：100027 办公室电话：010-56676893
        传真：010-56676893 电子邮箱：caua99@163.com
      </div>
      <div>
        本站最佳浏览效果：1024*768分辨率/建议使用Chrome浏览器或微软公司浏览器IE11以上
      </div>
      <a
        href="https://beian.mps.gov.cn/#/query/webSearch?code=11010502055017"
        rel="noreferrer"
        target="_blank"
        class="a-gov"
      >
        <div class="gov">
          <img src="@/assets/gongan.png" />
          <span>京公网安备11010502055017</span>
        </div>
      </a>
      <div class="keep-record">
        备案号：
        <a target="_blank" href="http://beian.miit.gov.cn">
          京ICP备14008645号-1
        </a>
        |
        <a target="_blank" href="http://beian.miit.gov.cn"
          >京ICP备14008645号-2</a
        >
      </div>
    </footer>
  </div>
</template>

<script>
import router from "vue-router";
import store from "@/store";
import Api from "@/api/searchApi";
import HomeApi from "@/api/homeApi";
import Filter from "@/util/filter";

export default {
  name: "App",
  data() {
    return {
      menuList: [
        {
          name: "关于我们",
          key: "about",
          immutable: true,
          subNav: [
            { name: "协会简介", id: 0 },
            // { name: "协会领导", id: 1 },
            { name: "组织机构", id: 2 },
            { name: "协会章程", id: 3 },
          ],
        },
        {
          name: "新闻资讯",
          key: "news",
          immutable: false,
          subNav: [],
        },
        {
          name: "党政建设",
          key: "policy_building",
          immutable: false,
          subNav: [],
        },
        {
          name: "老年教育",
          key: "old_age_education",
          immutable: false,
          subNav: [],
        },
        {
          name: "专题报导",
          key: "special_report",
          immutable: false,
          subNav: [],
        },
        {
          name: "信息公开",
          key: "information_open",
          immutable: false,
          subNav: [{ name: "谏言献策", id: -1 }],
        },
        {
          name: "网上老年大学",
          key: "wslndx",
          immutable: true,
          subNav: [
            { name: "网上老年大学简介", id: 0 },
            { name: "网上老年大学领导", id: 1 },
          ],
        },
        {
          name: "数字化校园",
          key: "online_service",
          immutable: false,
          subNav: [],
        },
      ],
      searchKey: "",
      searchRes: {},
    };
  },
  created() {
    this.getFristCategory();
  },
  computed: {
    nav() {
      const path1 = this.$route.path.split("/")[1];
      return Filter.HomeNavFilter(path1) ? Filter.HomeNavFilter(path1) : 1;
    },
    storeMenuList() {
      return store.state.Home.menuList;
    },
  },
  methods: {
    getFristCategory() {
      HomeApi.getFristCategory().then((res) => {
        this.menuList.map((item) => {
          item.immutable
            ? ""
            : (item.subNav = [...res.data[item.key], ...item.subNav]);
        });
        store.commit(
          "Home/setMenuList",
          JSON.parse(JSON.stringify(this.menuList))
        );
      });
    },
    handleSearch() {
      if (this.searchKey) {
        this.$router.push(`/search/${this.searchKey}/${Math.random()}`);
        store.commit("Search/searchKey", this.searchKey);
        this.searchKey = "";
      }
    },
    handleSelect(index, indexPath) {
      if (indexPath.length >= 2) {
        const current = this.menuList[indexPath[0]];
        const path = `/${current.key}/${current.subNav[indexPath[1]].id}`;
        this.$router.push(path);
      }
    },
    // 点击标签跳转
    handleNavClick(path, n) {
      this.$router.push({ path: path });
      setTimeout(() => {
        this.$refs["el-menu"].close(n - 2 + "");
      }, 400);
    },
  },
};
</script>

<style lang="scss">
.el-menu::after,
.el-menu::before {
  display: none !important;
}

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom-width: 0 !important;
}

.el-menu--horizontal > .el-submenu .el-submenu__icon-arrow {
  font-size: 0;
  display: none !important;
}

.el-menu-item {
  font-size: 18px !important;
}

.el-submenu__title {
  text-align: center;
  padding: 0 30px !important;
}

.level-one {
  display: block;
  height: 60px;
  line-height: 60px;
  opacity: 0.8;
  font-size: 18px;
  color: #efefef;
  letter-spacing: 0.51px;
  text-align: center;
  &._active {
    opacity: 1;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0.51px;
  }
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom-width: 0 !important;
}

.el-menu--popup {
  background-color: #fff !important;
  width: 134px !important;
  min-width: 134px !important;
  margin: 0;
  // padding: 5px 15px;
  // box-sizing: border-box;
  .el-menu-item {
    background-color: #fff !important;
    color: #3a3a3a !important;
    text-align: center;
    padding: 0 !important;
    font-size: 16px !important;
    &:hover {
      background-color: #eaeaea !important;
      color: #c52e0f !important;
    }
  }
}
.popper6 {
  width: 171px !important;
  // background: #FFF;
  // display: flex;
  // flex-direction: column;
  // justify-content: center;
  // align-items: center;
  ul {
    width: 100% !important;
    li {
      display: block;
      width: 100% !important;
    }
  }
}
.popper7 {
  width: 160px !important;
  ul {
    width: 100% !important;
    li {
      display: block;
      width: 100% !important;
    }
  }
}
</style>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  background: #f4f4f4;
}
#app {
  font-family: "Microsoft Yahei", Microsoft YaHei, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.header {
  width: 1200px;
  height: 150px;
  padding: 0 calc((100% - 1200px) / 2);
  color: white;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;

  .bg-img {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 150px;
    background-image: url("./assets/header.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    transform: scale(1);
    animation: bgScale 2s;
  }

  img {
    position: absolute;
    left: calc((100% - 1200px) / 2);
    top: 30px;
    width: 420px;
  }

  .dialog-search {
    width: 300px;
    border-radius: 20px;
    overflow: hidden;
    .el-input__inner:focus {
      border: 1px solid #dcdfe6 !important;
    }
    .el-icon-search {
      font-size: 18px;
      color: #4a4a4a;
    }
  }

  .translation-font {
    padding-left: 24px;
    list-style: none;
    font-size: 18px;
    line-height: 40px;
    color: #f1f1f1;
    letter-spacing: 0.51px;

    & > li {
      display: inline-block;
    }

    span {
      font-size: 14px;
      margin: 0 5px;
      vertical-align: bottom;
    }
  }
}

.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 calc((100% - 1200px) / 2) !important;
  background: #8c0e01;
  min-width: 1200px;
  height: 60px;
  margin-top: -1px;
  margin-bottom: 0;
}

@keyframes bgScale {
  from {
    transform: scale(1.1);
  }
  to {
    transform: scale(1);
  }
}

.website-description {
  text-align: center;
  background: #4e252c;
  min-width: 1200px;
  height: 230px;
  padding-top: 45px;

  p {
    font-size: 16px;
    color: #e0e0e0;
    letter-spacing: 0.34px;
  }

  div {
    &:nth-child(2) {
      height: 60px;
      line-height: 60px;
      font-size: 14px;
      color: #c3c3c3;
      letter-spacing: 0.34px;
      margin-bottom: 15px;

      a {
        text-decoration: none;
      }

      a:link {
        color: #c3c3c3;
      }

      a:visited {
        color: #c3c3c3;
      }
    }

    &:nth-child(3) {
      font-size: 12px;
      color: #8f8f8f;
      letter-spacing: 0;
      line-height: 21px;
    }

    &:nth-child(4) {
      font-size: 12px;
      color: #8f8f8f;
      letter-spacing: 0;
      line-height: 21px;
    }
  }
  .a-gov {
    font-size: 12px;
    color: #8f8f8f;
    letter-spacing: 0;
    line-height: 21px;
    .gov {
      display: flex;
      height: 20px;
      align-items: center;
      justify-content: center;
      span {
        margin-left: 5px;
      }
    }
  }
  .keep-record {
    font-size: 12px;
    color: #8f8f8f;
    letter-spacing: 0;
    line-height: 21px;
    a {
      font-size: 12px;
      color: #8f8f8f;
      letter-spacing: 0;
      line-height: 21px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue